/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { CONFIGURABLE_MENU_IDS_AS_STRINGS } from '../../constants/index.tsx';
import type { ConfigurableMenuId } from '../../types.tsx';

export const isConfigurableMenuId = (value: string): value is ConfigurableMenuId =>
	CONFIGURABLE_MENU_IDS_AS_STRINGS.includes(value);
